import Vue from 'vue';
import Vuex from 'vuex';
import VueCompositionApi from "@vue/composition-api";
import VueShowdown from 'vue-showdown';
import WokComponents from 'wok-components/src/index';
import Components from './components';

Vue.config.productionTip = false;
Vue.use(VueCompositionApi);
Vue.use(Vuex);
Vue.use(WokComponents);
Vue.use(Components);
Vue.use(VueShowdown, {
    options: {
        noHeaderId: true
    }
});

import { filters } from './helpers/filters';

Vue.mixin({ filters });

import { init as initRouter } from './router';
import { init as initI18n } from './i18n';
import { init as initApi } from './helpers/api';
import { getStore } from './store';

import App from './App.vue';

initApi(options => {
    options.authenticationClientId = 'finder-accounts';
});

new Vue({
    store: getStore(),
    router: initRouter(),
    i18n: initI18n(),
    render: h => h(App)
}).$mount('#app')

// Generate CSS
import '../styles/main.pcss';
